import API from "../../../Api/API"
const api = new API()

export const getMeApi = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await api.get("/auth/me")
      if (result && result.data) {
        resolve(result)
      } else {
        reject(new Error("Empty response from /auth/me"))
      }
    } catch (error) {
      reject(error)
    }
  })
}
